export const Types = {
  CHECK_TOKEN: "password/CHECK_TOKEN",
  TOKEN_SUCCESS: "password/CHECK_TOKEN_SUCCESS",
  RESET_REQUEST: "password/RESET_REQUEST",
  RESET_SUCCESS: "password/RESET_SUCCESS"
};

const INITIAL_STATE = {
  loadingCheckToken: true,
  loading: false,
  status: "initial"
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.TOKEN_SUCCESS:
      return { ...state, loadingCheckToken: false };

    case Types.RESET_REQUEST:
      return { ...state, loading: true };

    case Types.RESET_SUCCESS:
      return { loading: false, status: "success" };

    default:
      return state;
  }
};

export const Creators = {
  checkToken: token => ({
    type: Types.CHECK_TOKEN,
    payload: { token }
  }),
  tokenSuccess: () => ({ type: Types.TOKEN_SUCCESS }),
  resetPassword: (password, password_confirmation, token, baseUrl) => ({
    type: Types.RESET_REQUEST,
    payload: { password, password_confirmation, token, baseUrl }
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/resetPassword.js